var exports = {
  "Y": "StatusCheckHeader__JgU5q5",
};

module.exports = exports;
